// Inspection-form constants pulled out of InspectionForm.jsx so they can be
// shared, tree-shaken, and unit-tested without importing React.

export const MILESTONES = [
  "Start", "10%", "25%", "40%", "55%", "70%", "85%", "100%",
  "Final-QC-before-cutting", "Ad-hoc",
];
export const NUMERIC = ["10%", "25%", "40%", "55%", "70%", "85%", "100%"];

export const DOMAINS = [
  { key: "quality",     labelKey: "domain_quality",     items: ["design_matches_graph", "motif_alignment", "knot_evenness", "yarn_colour", "no_loose_knots"] },
  { key: "measurement", labelKey: "domain_measurement", items: ["width_consistency", "straightness", "selvage", "pile_consistency"] },
  { key: "progress",    labelKey: "domain_progress",    items: ["on_pace_vs_eta", "daily_rate"] },
  { key: "loom_weaver", labelKey: "domain_loom_weaver", items: ["setup_stable", "tools_available", "helper_available"] },
  { key: "risk",        labelKey: "domain_risk",        items: ["delay_risk", "quality_risk", "absenteeism", "yarn_shortage"] },
];

export const CHECK_LABELS = {
  design_matches_graph: { en: "Design matches graph", hi: "डिज़ाइन ग्राफ़ से मिलता है" },
  motif_alignment:      { en: "Motif / border alignment", hi: "मोटिफ़ / बॉर्डर सीध" },
  knot_evenness:        { en: "Knot evenness", hi: "गाँठ एकसमान" },
  yarn_colour:          { en: "Yarn colour / no dye-lot variation", hi: "यार्न रंग एकसमान" },
  no_loose_knots:       { en: "No missing/loose knots", hi: "कोई ढीली गाँठ नहीं" },
  width_consistency:    { en: "Width consistency", hi: "चौड़ाई एकसमान" },
  straightness:         { en: "Straightness", hi: "सीधापन" },
  selvage:              { en: "Selvage condition", hi: "किनारा" },
  pile_consistency:     { en: "Pile height consistency", hi: "पाइल ऊँचाई" },
  on_pace_vs_eta:       { en: "On pace vs ETA", hi: "समय पर है" },
  daily_rate:           { en: "Daily rate noted", hi: "रोज़ की दर" },
  setup_stable:         { en: "Loom setup stable", hi: "लूम स्थिर" },
  tools_available:      { en: "Tools available", hi: "उपकरण उपलब्ध" },
  helper_available:     { en: "Helper available", hi: "सहायक उपलब्ध" },
  delay_risk:           { en: "Delay risk", hi: "देरी का जोखिम" },
  quality_risk:         { en: "Quality risk", hi: "गुणवत्ता जोखिम" },
  absenteeism:          { en: "Absenteeism", hi: "अनुपस्थिति" },
  yarn_shortage:        { en: "Yarn shortage", hi: "यार्न कमी" },
};

/** Returns the first missing prior numeric milestone if any (else null). */
export function firstSkippedMilestone(current, priorMilestones) {
  if (!NUMERIC.includes(current)) return null;
  const idx = NUMERIC.indexOf(current);
  for (let i = 0; i < idx; i++) {
    if (!priorMilestones.includes(NUMERIC[i])) return NUMERIC[i];
  }
  return null;
}
